module.exports = __webpack_public_path__ + "img/home-4.b2d9439c.png";